<template>
    <tr @click.stop="showChannelDetail(row['id'])">
      <td v-if="!printMode" colspan="2" class="no_padding"></td>
        <td :data-th="'Název kanálu' | translate" class="first_data"><strong>{{ row['name'] }}</strong></td>

        <td class="center" :data-th="name" v-for="(channel, name) in channels">
        <img
                      class="is_set"
                      src="../../../../assets/images/is-set.svg"
                      :alt="'Ano' | translate"
                      v-if="channel">
        </td>
    </tr>
</template>

<script>
	import links from "../../../mixins/links";

  export default {
		name: "ProgramStructureRow",
		props: {
			row: Object,
      printMode: Boolean
		},
    mixins: [links],
    computed: {
      channels(){
        let rows = {...this.row};
        delete rows['id'];
        delete rows['name'];
        return rows;
      }
    }
	}
</script>



// WEBPACK FOOTER //
// src/components/views/downloads/program-structure/ProgramStructureRow.vue